import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRouting, AppRoutingProviders } from './app.routing';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { AppComponent } from './app.component';
import { AuthService } from './providers/authentication/auth.service';
import { SSOService } from './providers/authentication/sso/sso.service';
import { SSO } from './providers/nom-web-services-json/sso';
import { ENPSService } from './providers/authentication/enps/enps.service';

@NgModule({
    declarations: [AppComponent],
    imports: [BrowserModule, AppRouting, HttpClientModule, HttpModule, OAuthModule.forRoot()],
    providers: [AppRoutingProviders, OAuthService, AuthService, SSOService, SSO, ENPSService],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts